"use client";
import { useEffect } from "react";
import { hotjar } from "react-hotjar";

function Hotjar() {
  useEffect(() => {
    // if (process.env.NODE_ENV !== 'development') {
    hotjar.initialize({
      id: 5026319,
      sv: 6,
    });
    // }
  }, []);

  return <></>;
}

export default Hotjar;
